export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/AE-86d92aeca61777ffa76bdd5ab11eca17.png";